/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6.73004 2.54497C7.7996 2 9.19973 2 12 2C14.8003 2 16.2004 2 17.2699 2.54497C18.2108 3.02433 18.9757 3.78924 19.455 4.73005C20 5.79961 20 7.19974 20 10V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 4L4.19751 5.75801M22 20L20 18.4M20 18.4V22L19.1554 21.5777C15.6442 19.8221 13.8885 18.9443 12 18.9443C10.1115 18.9443 8.35582 19.8221 4.84458 21.5777L4 22V10C4 8.00348 4 6.7187 4.19751 5.75801M20 18.4L4.19751 5.75801"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M4 9.9998V21.9998L4.84458 21.5775L4.8446 21.5775C8.35582 19.8219 10.1115 18.9441 12 18.9441C13.8885 18.9441 15.6442 19.8219 19.1554 21.5775L19.1554 21.5775L20 21.9998V18.3998L4.19751 5.75781C4 6.7185 4 8.00329 4 9.9998Z"
				fill="currentColor"
			/>
			<path
				d="M6.73005 2.54497C7.79961 2 9.19974 2 12 2C14.8003 2 16.2004 2 17.27 2.54497C18.2108 3.02433 18.9757 3.78924 19.455 4.73005C20 5.79961 20 7.19974 20 10V14M2 4L4.19751 5.75801M22 20L20 18.4M20 18.4V22L19.1554 21.5777C15.6442 19.8221 13.8885 18.9443 12 18.9443C10.1115 18.9443 8.35582 19.8221 4.84458 21.5777L4 22V10C4 8.00348 4 6.7187 4.19751 5.75801M20 18.4L4.19751 5.75801"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M11.9664 1.25C10.5947 1.25 9.51928 1.24999 8.65493 1.32061C7.77479 1.39252 7.04768 1.54138 6.38955 1.87671C6.02048 2.06476 5.87374 2.51639 6.06179 2.88546C6.24984 3.25453 6.70147 3.40127 7.07054 3.21322C7.48197 3.00359 7.9897 2.87996 8.77708 2.81563C9.57322 2.75058 10.5875 2.75 12 2.75C13.4125 2.75 14.4268 2.75058 15.2229 2.81563C16.0103 2.87996 16.518 3.00359 16.9295 3.21322C17.7291 3.62068 18.3793 4.27085 18.7868 5.07054C18.9964 5.48197 19.12 5.9897 19.1844 6.77708C19.2494 7.57322 19.25 8.58749 19.25 10V14C19.25 14.4142 19.5858 14.75 20 14.75C20.4142 14.75 20.75 14.4142 20.75 14V9.96642C20.75 8.59473 20.75 7.51927 20.6794 6.65494C20.6075 5.77479 20.4586 5.04768 20.1233 4.38956C19.572 3.30762 18.6924 2.42798 17.6104 1.87671C16.9523 1.54138 16.2252 1.39252 15.3451 1.32061C14.4807 1.24999 13.4053 1.25 12.0336 1.25H11.9664Z"
				fill="currentColor"
			/>
			<path
				d="M2.46852 3.41435C2.14507 3.15559 1.6731 3.20803 1.41435 3.53148C1.15559 3.85493 1.20803 4.32689 1.53148 4.58565L3.38441 6.068C3.2499 7.0375 3.24994 8.26335 3.24999 9.89923L3.25 22C3.25 22.2599 3.38459 22.5013 3.6057 22.638C3.82681 22.7746 4.10292 22.7871 4.33541 22.6708L5.17999 22.2485C8.75857 20.4592 10.3301 19.6943 12 19.6943C13.6699 19.6943 15.2414 20.4592 18.82 22.2485L19.6646 22.6708C19.8971 22.7871 20.1732 22.7746 20.3943 22.638C20.6154 22.5013 20.75 22.2599 20.75 22V19.9605L21.5315 20.5857C21.8549 20.8444 22.3269 20.792 22.5856 20.4685C22.8444 20.1451 22.792 19.6731 22.4685 19.4143L2.46852 3.41435Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M6.73005 2.54497C7.79961 2 9.19974 2 12 2C14.8003 2 16.2004 2 17.27 2.54497C18.2108 3.02433 18.9757 3.78924 19.455 4.73005C20 5.79961 20 7.19974 20 10V14M2 4L4.19751 5.75801M22 20L20 18.4M20 18.4V22L19.1554 21.5777C15.6442 19.8221 13.8885 18.9443 12 18.9443C10.1115 18.9443 8.35582 19.8221 4.84458 21.5777L4 22V18M20 18.4L4.19751 5.75801M4.19751 5.75801C4 6.7187 4 8.00348 4 10V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6.73005 2.54497C7.79961 2 9.19974 2 12 2C14.8003 2 16.2004 2 17.27 2.54497C18.2108 3.02433 18.9757 3.78924 19.455 4.73005C20 5.79961 20 7.19974 20 10V14M2 4L4.19751 5.75801M22 20L20 18.4M20 18.4V22L19.1554 21.5777C15.6442 19.8221 13.8885 18.9443 12 18.9443C10.1115 18.9443 8.35582 19.8221 4.84458 21.5777L4 22V10C4 8.00348 4 6.7187 4.19751 5.75801M20 18.4L4.19751 5.75801"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M3.25003 9.89923C3.24998 8.26334 3.24994 7.0375 3.38445 6.06799L20.75 19.9605V22C20.75 22.2599 20.6154 22.5013 20.3943 22.638C20.1732 22.7746 19.8971 22.7871 19.6646 22.6708L18.82 22.2485C15.2415 20.4592 13.6699 19.6943 12 19.6943C10.3301 19.6943 8.75861 20.4592 5.18003 22.2485L4.33545 22.6708C4.10295 22.7871 3.82685 22.7746 3.60574 22.638C3.38462 22.5013 3.25004 22.2599 3.25004 22L3.25003 9.89923Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9664 1.25L12 1.25L12.0336 1.25C13.4053 1.25 14.4807 1.24999 15.3451 1.32061C16.2252 1.39252 16.9523 1.54138 17.6104 1.87671C18.6924 2.42798 19.572 3.30762 20.1233 4.38956C20.4586 5.04768 20.6075 5.77479 20.6794 6.65494C20.75 7.51928 20.75 8.59471 20.75 9.96642V10V14C20.75 14.4142 20.4142 14.75 20 14.75C19.5858 14.75 19.25 14.4142 19.25 14V10C19.25 8.58749 19.2494 7.57322 19.1844 6.77708C19.12 5.9897 18.9964 5.48197 18.7868 5.07054C18.3793 4.27085 17.7291 3.62068 16.9295 3.21322C16.518 3.00359 16.0103 2.87996 15.2229 2.81563C14.4268 2.75058 13.4125 2.75 12 2.75C10.5875 2.75 9.57322 2.75058 8.77708 2.81563C7.9897 2.87996 7.48197 3.00359 7.07054 3.21322C6.70147 3.40127 6.24984 3.25453 6.06179 2.88546C5.87374 2.51639 6.02048 2.06476 6.38955 1.87671C7.04768 1.54138 7.77479 1.39252 8.65493 1.32061C9.51928 1.24999 10.5947 1.25 11.9664 1.25ZM1.41435 3.53148C1.6731 3.20803 2.14507 3.15559 2.46852 3.41435L22.4685 19.4143C22.792 19.6731 22.8444 20.1451 22.5856 20.4685C22.3269 20.792 21.8549 20.8444 21.5315 20.5857L1.53148 4.58565C1.20803 4.32689 1.15559 3.85493 1.41435 3.53148Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
